import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import framesServices from '@src/services/frames.services';

export const getCurrentFrames = createAsyncThunk(
  'getCurrentFrames',
  async (body, { rejectWithValue }) => {
    try {
      const response = await framesServices.getCurrentFrames(body);
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);
export const frameSave = createAsyncThunk('frameSave', async ({ body }, { rejectWithValue }) => {
  try {
    const result = await framesServices.saveFrame(body);
    return result;
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const framesGetList = createAsyncThunk(
  'framesGetList',
  async ({ body, pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      const result = await framesServices.getList({ body, pageNumber, pageSize });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const frameUpdate = createAsyncThunk(
  'frameUpdate',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await framesServices.updateFrame(body);
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const frameDelete = createAsyncThunk('frameDelete', async (id, { rejectWithValue }) => {
  try {
    const result = await framesServices.deleteFrame(id);
    return result;
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const frameGetById = createAsyncThunk('frameGetById', async (id, { rejectWithValue }) => {
  try {
    const result = await framesServices.getById(id);
    return result;
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

const initialState = {
  currentFrames: [],
  frameList: [],
  htmlTr: '',
  htmlEn: '',
  tableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
  filterObject: {
    body: [],
    pageNumber: 1,
    pageSize: 10,
  },
};

export const framesSlice = createSlice({
  name: 'frames',
  initialState,
  reducers: {
    setHtmlTr: (state, action) => {
      state.htmlTr = action.payload.tr;
    },
    setHtmlEn: (state, action) => {
      state.htmlEn = action.payload.en;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentFrames.fulfilled, (state, action) => {
      state.currentFrames = action?.payload?.data;
    });
    builder.addCase(framesGetList.fulfilled, (state, action) => {
      state.frameList = action?.payload?.data?.items || [];
      state.tableProperty = action?.payload?.data?.pagedProperty || initialState?.tableProperty;
    });
  },
});

export const { setHtmlEn, setHtmlTr } = framesSlice.actions;

export default framesSlice.reducer;
